import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const amber = '#B8860A';
const navy = '#1A3A6B';

function FormCard({ title, description, route, buttonName, eventImage }) {
  return (
    <Card sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 2,
      boxShadow: 3,
      transition: 'box-shadow 0.2s',
      '&:hover': { boxShadow: 6 },
    }}>
      <CardMedia
        component="img"
        height="350"
        image={eventImage}
        alt={title}
        sx={{ objectFit: 'cover' }}
      />
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 3 }}>
        <Typography
          variant="h6"
          sx={{ color: navy, fontWeight: 700, fontFamily: 'Georgia, serif', mb: 0.5, fontSize: '1rem' }}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1, flexGrow: 1 }}>
            {description}
          </Typography>
        )}
        <Box sx={{ mt: 'auto', pt: 1 }}>
          <Button
            component={Link}
            to={route}
            variant="contained"
            fullWidth
            sx={{ backgroundColor: amber, color: '#fff', fontWeight: 700, borderRadius: 1, '&:hover': { backgroundColor: '#9a6f08' } }}
          >
            {buttonName}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default FormCard;